import React, { useState } from 'react';
import { api } from '../App';
import '../styles/LoginPage.css';

function LoginPage({ onLogin }) {
  const [inlognaam, setInlognaam] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/index.php?action=login', {
        inlognaam,
        wachtwoord
      });

      if (response.data.user) {
        onLogin(response.data.user);
      }
    } catch (err) {
      if (!err.response) {
        setError('Geen verbinding met de server. Controleer je internet en gebruik https://vakantieervaringen.nl (zonder www in de adresbalk).');
      } else {
        setError(err.response?.data?.message || 'Er is een fout opgetreden bij het inloggen');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div
        className="login-hero"
        style={{ backgroundImage: "url('/images/login-hero.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">KAMPBOODSCHAPPEN</h1>
          <p className="hero-subtitle">Scoutinggroep John McCormick</p>
        </div>
      </div>

      <div className="login-box">
        <div className="logo-section">
          <img src="/images/jmc-logo.png" alt="JMC Logo" className="jmc-logo-img" />
        </div>

        <div className="form-container">
          <h2 className="form-title">Bestelportaal</h2>
          <p className="form-subtitle">Meld je aan met je gegevens</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="inlognaam">Gebruikersnaam</label>
              <input
                type="text"
                id="inlognaam"
                value={inlognaam}
                onChange={(e) => setInlognaam(e.target.value)}
                placeholder="Voer je gebruikersnaam in"
                required
                disabled={loading}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="wachtwoord">Wachtwoord</label>
              <div className="password-input-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="wachtwoord"
                  value={wachtwoord}
                  onChange={(e) => setWachtwoord(e.target.value)}
                  placeholder="Voer je wachtwoord in"
                  required
                  disabled={loading}
                  className="form-input password-input"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword((visible) => !visible)}
                  disabled={loading}
                  aria-label={showPassword ? 'Wachtwoord verbergen' : 'Wachtwoord tonen'}
                  aria-pressed={showPassword}
                >
                  {showPassword ? (
                    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                      <path
                        fill="currentColor"
                        d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-.62 1.27-1.53 2.4-2.64 3.33l1.42 1.42c1.5-1.26 2.7-2.89 3.43-4.75-1.65-3.37-5.03-5.5-8.82-5.5-1.09 0-2.14.2-3.12.56l1.55 1.55c.5-.12 1.03-.19 1.57-.19M3.18 4.18 1.76 5.6l2.05 2.05C2.73 8.61 1 11.72 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l2.28 2.28 1.42-1.42L3.18 4.18zm6.1 6.1 1.53 1.53c-.05-.34-.08-.69-.08-1.03 0-1.38 1.12-2.5 2.5-2.5.34 0 .69.03 1.03.08l1.53 1.53A2.5 2.5 0 0 0 12 9c-.55 0-1.06.18-1.47.48l1.15 1.15zM12 17.5c-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53l1.42 1.42c-.9.64-1.63 1.5-2.13 2.47 1.65 3.37 5.03 5.5 8.82 5.5 1.09 0 2.14-.2 3.12-.56l1.55 1.55c-1.03.4-2.16.62-3.32.62z"
                      />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                      <path
                        fill="currentColor"
                        d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.03 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Bezig met inloggen...' : 'Inloggen'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
